import React from "react";
import { useImbox } from "Shared/util/custom-hooks";
import { toggleImbox } from "Shared/util/imbox-api";
import InlineSvg from "Shared/components/inline-svg";
import styles from "./login.css";

export const ImboxToggler = () => {
  useImbox();

  const handleToggleImbox = () => {
    toggleImbox();
  };

  return (
    <InlineSvg
      className={styles.imboxToggler}
      onClick={handleToggleImbox}
      src="/imbox.svg"
    />
  );
};
